import refundReasons from 'constants/refundReasons'

export const getRefundReasons = (translations, isInternational) => {
  const bundle = isInternational ? 'international-refund-form' : 'general.refund-form'
  return [
    {
      value: refundReasons.CANCEL,
      label: translations(`${bundle}.refund-reasons.cancel`)
    },
    {
      value: refundReasons.RESCHEDULE,
      label: translations(`${bundle}.refund-reasons.reschedule`)
    },
    {
      value: refundReasons.AIRPORT_CHANGE,
      label: translations(`${bundle}.refund-reasons.airport-change`)
    },
    {
      value: refundReasons.SICKNESS,
      label: translations(`${bundle}.refund-reasons.sickness`)
    },
    {
      value: refundReasons.DEATH,
      label: translations(`${bundle}.refund-reasons.death`)
    },
    {
      value: refundReasons.ISSUES,
      label: translations(`${bundle}.refund-reasons.personal-issues`)
    },
    {
      value: refundReasons.OTHER,
      label: translations(`${bundle}.refund-reasons.other`)
    }
  ]
}

export const getAccountType = translations => [
  {
    value: translations('general.refund-form.account-type.current-account'),
    label: translations('general.refund-form.account-type.current-account')
  },
  {
    value: translations('general.refund-form.account-type.savings-bank'),
    label: translations('general.refund-form.account-type.savings-bank')
  },
  {
    value: translations('general.refund-form.account-type.single-account'),
    label: translations('general.refund-form.account-type.single-account')
  }
]
